import React, { useEffect, useRef, useState } from "react";
import FormInput from "../../../components/FormGroup/FormInput";
import FormSelect from "../../../components/FormGroup/FormSelect";
import { usePrecandidateContext } from "../../precandidate/context/Context";
import { useTranslation } from "react-i18next";
import "./stylesCreate.scss";
import FileService from "../../../services/FileService";
import { useGeneralContext } from "../../General/Context";
import Datetime from "react-datetime";
import { Files } from "../Files/Files";
import ModalContainer from "../../../containers/Modal/ModalContainer";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import pt from "react-phone-number-input/locale/pt";
import es from "react-phone-number-input/locale/es";
import fr from "react-phone-number-input/locale/fr";
import en from "react-phone-number-input/locale/en";
import { JobRoleDetailService } from "../../../services/JobRoleDetailService";
import { DropDownMultiCheck } from "../../Interview/AdvanceSearch/DropDownMultiCheck";

const CreatePrecandidate = () => {
  const {
    precandidate,
    setPrecandidate,
    onChange,
    managers,
    candidateSources,
    candidateSourceRCIds,
    candidateSourceDFIds,
    errors
  } = usePrecandidateContext();

  const { userInformation } = useGeneralContext();
  const { t, i18n } = useTranslation();
  const [showParseConfirmation, setShowParseConfirmation] = useState(false);
  let fileBase64 = useRef([]);
  const [businessAreas, setBusinessAreas] = useState([]);
  const [techAreas, setTechAreas] = useState([]);
  const [techRoles, setTechRoles] = useState([]);

  function getBusinessAreas() {
    JobRoleDetailService.getAllBusinessAreas().then((data) => {
      setBusinessAreas(data);
    });
  }
  function getTechAreas() {
    JobRoleDetailService.getAllTechAreas().then((data) => {
      setTechAreas(data);
    });
  }
  function getTechRoles(techAreaId) {
    JobRoleDetailService.getAllTechRoles(techAreaId).then((data) => {
      setTechRoles(data);
    });
  }
  useEffect(() => {
    getBusinessAreas();
    getTechAreas();
  }, []);

  useEffect(() => {
    if (precandidate?.techAreaId) getTechRoles(precandidate.techAreaId);
  }, [precandidate?.techAreaId]);

  useEffect(() => {
    if (!precandidate.managerId)
      setPrecandidate({ ...precandidate, managerId: userInformation.id });
  }, []);

  function parseCvResult() {
    FileService.uploadBase64(fileBase64.current[0], "vitae/file/parse").then(
      (data) => {
        setUploadResult(data, fileBase64.current);
        setShowParseConfirmation(false);
      }
    );
  }

  function cancelComfirmationAndClose() {
    setPrecandidate({
      ...precandidate,
      fileBase64: precandidate.fileBase64
        ? precandidate.fileBase64.concat(fileBase64.current)
        : fileBase64.current
    });
    setShowParseConfirmation(false);
  }

  function showUpdateFieldsComfirmation(_fileBase64) {
    fileBase64.current = _fileBase64;
    setShowParseConfirmation(true);
  }

  const setUploadResult = (uploadResult, fileBase64) => {
    setPrecandidate({
      ...precandidate,
      phoneNumber: uploadResult.phoneNumber,
      emailAddress: uploadResult.emailAddress,
      fullName: uploadResult.fullName,
      fileBase64: precandidate.fileBase64
        ? precandidate.fileBase64.concat(fileBase64)
        : fileBase64
    });
  };

  function oncandidateSourceIdChange({ target }) {
    let _precandidate = { ...precandidate };
    if (!candidateSourceRCIds[target.value]) {
      _precandidate.recommendedByEmail = undefined;
      _precandidate.recommendedByName = undefined;
    }
    _precandidate.candidateSourceId = target.value;
    setPrecandidate(_precandidate);
  }

  const onChangeWasCreatedByMe = () => {
    setPrecandidate({
      ...precandidate,
      isCapturedByMe:
        precandidate.isCapturedByMe === undefined
          ? true
          : !precandidate.isCapturedByMe
    });
  };

  function onApplicationDaetChange(date) {
    setPrecandidate({ ...precandidate, applicationDate: date });
  }

  function onChangePhoneNumber(values) {
    onChange({
      target: {
        name: "phoneNumber",
        value: values
      }
    });
  }
  const onchangeBusinessAreas = (businessAreas) => {
    setPrecandidate({ ...precandidate, businessAreas: businessAreas });
  };

  return (
    <>
      <form controlId="formPrincipal" noValidate>
        <Files
          precandidate={precandidate}
          setPrecandidate={setPrecandidate}
          onSetResult={showUpdateFieldsComfirmation}
        />
        <div className="row">
          <div className="col-md-4" style={{ width: "33%" }}>
            <FormInput
              controlId="formGridName"
              errorMessage={errors.fullName}
              labelText={t("Full Name")}
              type="text"
              placeholder={t("Name")}
              value={precandidate?.fullName}
              onChange={onChange}
              id="fullName"
              name="fullName"
              isFieldRequired={true}
              maxLength={100}
            />
          </div>
          <div className="col-md-3" style={{ width: "33%" }}>
            <FormInput
              controlId="formGridEmail"
              errorMessage={errors.emailAddress}
              labelText={t("Email Address")}
              type="email"
              placeholder={t("name@example.com")}
              value={precandidate?.emailAddress}
              onChange={onChange}
              id="emailAddress"
              name="emailAddress"
              isFieldRequired={true}
              maxLength={100}
            />
          </div>
          <div className="col-md-2" style={{ width: "33%" }}>
            <div className="label-wrapper">
              <label htmlFor="personalDetailLabelPhoneNumber">
                {t("Mobile number")}
              </label>
              {errors.phoneNumber && (
                <div className="error-msg">{errors.phoneNumber}</div>
              )}
            </div>
            <PhoneInput
              className="input-field"
              errorMessage={errors.phoneNumber}
              labelText={t("Mobile number")}
              id="phoneNumber"
              name="phoneNumber"
              type="tel"
              international
              defaultCountry={
                userInformation.langCode === "ES"
                  ? "ES"
                  : userInformation.langCode === "EN" &&
                    userInformation.companyAbbreviation === "AGAP2NL"
                  ? "NL"
                  : userInformation.langCode === "EN" &&
                    userInformation.companyAbbreviation === "GMS"
                  ? "DE"
                  : "PT"
              }
              labels={
                i18n.language === "PT"
                  ? pt
                  : i18n.language === "FR"
                  ? fr
                  : i18n.language === "EN"
                  ? en
                  : es
              }
              countryCallingCodeEditable={false}
              value={precandidate?.phoneNumber}
              onChange={onChangePhoneNumber}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-3" style={{ width: "33%" }}>
            <div className="form-group">
              <div className="label-wrapper">
                <label className="label">{t("Business Area")}</label>
              </div>

              <DropDownMultiCheck
                dataList={businessAreas}
                selecteds={precandidate.businessAreas || []}
                setSelecteds={onchangeBusinessAreas}
                label={t("Business Area...")}
                hideSelected={true}
              />
            </div>
          </div>
          <div className="col-md-3" style={{ width: "33%" }}>
            <div className="form-group">
              <div className="label-wrapper">
                <label className="label">{t("Technical Area")}</label>
                {errors.techAreaId && (
                  <div className="error-msg">{errors.techAreaId}</div>
                )}
              </div>
              <select
                onChange={onChange}
                value={precandidate.techAreaId || ""}
                name="techAreaId"
                title={t("Select a Technical Area from the list")}
              >
                <option key={0} value="" selected>
                  {t("Technical Area...")}
                </option>
                {techAreas.map((item) => (
                  <option key={item.id} value={item.id}>
                    {t(item.description)}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-md-3" style={{ width: "33%" }}>
            <div className="form-group">
              <div className="label-wrapper">
                <label className="label">{t("Technical Role")}</label>
                {errors.techRoleId && (
                  <div className="error-msg">{errors.techRoleId}</div>
                )}
              </div>
              <select
                onChange={onChange}
                value={precandidate.techRoleId || ""}
                name="techRoleId"
                title={t("Select a Technical Role from the list")}
              >
                <option key={0} value="" selected>
                  {t("Technical Role...")}
                </option>
                {techRoles.map((item) => (
                  <option key={item.id} value={item.id}>
                    {t(item.description)}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
        <hr></hr>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <div className="label-wrapper">
                <label className="label">{t("Assign to")}</label>
              </div>
              <select
                value={precandidate?.managerId || 0}
                onChange={onChange}
                id="managerId"
                name="managerId"
                required
                title={t("Selecione um item da lista.")}
              >
                {managers.map((option) => (
                  <option key={option.id} value={option.id}>
                    {t(option.nickname)}
                  </option>
                ))}
              </select>{" "}
            </div>
          </div>
          <div className="col-md-3">
            <div className="label-wrapper">
              {" "}
              <label className="label">{t("Apllication Date")}</label>
            </div>
            <Datetime
              initialValue={precandidate?.applicationDate}
              id="nextContactDate"
              name="nextContactDate"
              dateFormat="DD-MM-YYYY"
              onChange={onApplicationDaetChange}
              utc={true}
              timeFormat={false}
              closeOnSelect={true}
              locale={
                i18n.language === "PT"
                  ? "PT"
                  : i18n.language === "FR"
                  ? "FR"
                  : "EN"
              }
              inputProps={{
                placeholder: t("dd-mm-yyyy")
              }}
            />
          </div>
          <div className="col-md-3">
            <FormSelect
              labelText={t("Source")}
              isFieldRequired={true}
              errorMessage={errors.candidateSourceId}
            >
              <select
                value={precandidate?.candidateSourceId || ""}
                onChange={oncandidateSourceIdChange}
                id="candidateSourceId"
                name="candidateSourceId"
                required
                title={t("Selecione um item da lista.")}
              >
                <option key={0} value="" selected disabled>
                  {t("Select Source...")}
                </option>
                {candidateSources.map((option) => (
                  <option key={option.id} value={option.id}>
                    {t(option.description)}
                  </option>
                ))}
              </select>{" "}
            </FormSelect>
          </div>
          <div className="col-md-2 field-width-captured">
            <div className="label-wrapper">
              <label className="label">{t("Captured by me ?")}</label>
            </div>
            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="isCapturedByMe"
                name="isCapturedByMe"
                onChange={onChangeWasCreatedByMe}
                disabled={
                  candidateSourceDFIds[precandidate?.candidateSourceId]
                    ? false
                    : true
                }
                checked={
                  candidateSourceDFIds[precandidate?.candidateSourceId]
                    ? precandidate.isCapturedByMe
                    : false
                }
                value={precandidate.isCapturedByMe}
              />
            </div>
          </div>
        </div>
        {candidateSourceRCIds[precandidate?.candidateSourceId] ? (
          <div className="row">
            <div className="col">
              <FormInput
                controlId="formGridRecommendedName"
                errorMessage={errors.recommendedByName}
                labelText={t("Recommended by name")}
                type="email"
                placeholder={t("Name")}
                value={precandidate?.recommendedByName || ""}
                onChange={onChange}
                id="recommendedByName"
                name="recommendedByName"
                isFieldRequired={true}
              />
            </div>
            <div className="col">
              <FormInput
                controlId="formGridRecommendedEmail"
                errorMessage={errors.recommendedByEmail}
                labelText={t("Recommended by Email")}
                type="email"
                placeholder={t("name@example.com")}
                value={precandidate?.recommendedByEmail || ""}
                onChange={onChange}
                id="recommendedByEmail"
                name="recommendedByEmail"
                isFieldRequired={true}
              />
            </div>
          </div>
        ) : (
          <div className="row">
            <div className="col">
              <FormInput
                controlId="formGridRecommendedName"
                errorMessage={errors.recommendedByName}
                labelText={t("Recommended by name")}
                type="email"
                placeholder={t("Name")}
                value={precandidate?.recommendedByName || ""}
                onChange={onChange}
                id="recommendedByName"
                name="recommendedByName"
                isFieldRequired={true}
                disabled={true}
              />
            </div>
            <div className="col">
              <FormInput
                controlId="formGridRecommendedEmail"
                errorMessage={errors.recommendedByEmail}
                labelText={t("Recommended by Email")}
                type="email"
                placeholder={t("name@example.com")}
                value={precandidate?.recommendedByEmail || ""}
                onChange={onChange}
                id="recommendedByEmail"
                name="recommendedByEmail"
                isFieldRequired={true}
                disabled={true}
              />
            </div>
          </div>
        )}
        <div className="col-md">
          <div className="label-wrapper">
            <label className="label">{t("Notes")}</label>
          </div>
          <textarea
            id="comment"
            name="comment"
            className="form-control"
            rows="3"
            value={precandidate?.comment}
            onChange={onChange}
            maxLength={500}
            placeholder={t("Your notes here...")}
          />
        </div>
      </form>
      <ModalContainer
        modalTitle={t("Update")}
        closeModal={cancelComfirmationAndClose}
        crossmarkAction={cancelComfirmationAndClose}
        cancelButtonTitle={t("Cancel")}
        cancelButtonAction={cancelComfirmationAndClose}
        submitButtonTitle={t("Ok")}
        submitButtonType="submit"
        submitButtonAction={parseCvResult}
        isOpen={showParseConfirmation}
      >
        {t(
          "Do you want to update the pre-candidate information with the existing information in the file"
        )}
      </ModalContainer>
    </>
  );
};

export default CreatePrecandidate;
